import './style.css'

import React, { Component } from 'react'

import Constants from '../../Phi/Constants'
import { Glyphicon } from 'react-bootstrap'
import PropTypes from 'prop-types'

export default class HeaderDropdown extends Component {

    render() {
        return (
        <div className="hsg-header-dropdown-root">

            {
                // Constants.userPermissionMap[this.props.roleType] && Constants.userPermissionMap[this.props.roleType].includes(Constants.userPermissionId.EDIT) &&
                <div>

                    {/* User Email */}
                    <i><p className="hsg-header-dropdown-email">{this.props.email}</p></i>

                    {/* Manage Profile Button */}
                    {/* {this.props.manageProfile &&
                        <div
                            className="hsg-header-dropdown-profile-button"
                            onClick={() => this.props.onClickManageProfile()}>

                            MANAGE PROFILE

                        </div>} */}


                    <div className="hsg-header-dropdown-main-divider" />

                </div>
            }


            {/* Menu Options */}
            {
                // Constants.userPermissionMap[this.props.roleType] && Constants.userPermissionMap[this.props.roleType].includes(Constants.userPermissionId.EDIT) &&
                <div>

                    <div className="hsg-header-dropdown-divider" />

                    <div
                        className="hsg-header-dropdown-menu-option"
                        onClick={() => this.props.onClickChangePassword()}>
                        
                        <span className="hsg-header-dropdown-icon"><i className="fas fa-key" /></span>

                        <span>{` CHANGE PASSWORD`}</span>

                    </div>

                </div>
            }
            <div>

                <div className="hsg-header-dropdown-divider"/>

                <div
                    className="hsg-header-dropdown-menu-option"
                    onClick={() => this.props.onClickSupport()}>
                    
                    <span className="hsg-header-dropdown-icon"><i className="far fa-question-circle" /></span>

                    <span>{` SUPPORT`}</span>

                </div>

            </div>
            <div>

                <div className="hsg-header-dropdown-divider" />

                <div
                    className="hsg-header-dropdown-menu-option"
                    onClick={() => this.props.onClickLogout()}>
                    
                    <span className="hsg-header-dropdown-icon"><Glyphicon glyph="log-out" /></span>

                    <span>{` LOGOUT`}</span>

                </div>

            </div>

        </div>);
    }

}



HeaderDropdown.propTypes = {
    email: PropTypes.string.isRequired,

    manageProfile: PropTypes.bool,
    onClickManageProfile: PropTypes.func,

    onClickLogout: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/Components/HeaderDropdown/index.js